import { useCallback as p } from "react";
import { useSearchContext as d } from "./help-center-articles-search3.js";
function w() {
  const { logger: o, applicationName: i } = d();
  function r() {
    return typeof window < "u" && window?.tracking !== void 0 && typeof window.tracking.track < "u";
  }
  return [p((c) => {
    if (!r()) {
      o?.error("Tracking is not initialized");
      return;
    }
    const { eventName: s, data: e } = c, n = (l) => document?.querySelector(`meta[name="${l}"]`)?.content || "", a = n("pageName"), u = n("pageSection");
    let t;
    typeof e.resultsLength == "number" && typeof e.resultPosition == "number" && (t = `${a};${e.resultDestination};${e.resultsLength};${e.resultPosition + 1}`);
    const g = {
      application: i,
      ...e,
      pageName: a,
      pageStage: "Customer Care",
      pageSection: u,
      ...t && { eventDetail: t }
    };
    window?.tracking?.track(s, g);
  }, [])];
}
export {
  w as default
};
//# sourceMappingURL=help-center-articles-search18.js.map
